import { r as o, h as e, H as a } from "./main-bb89b2f2.js";
import "vue";
const s = "*,:after,:before{border-color:var(--color-neutral-steel-200);border-style:solid;border-width:0;box-sizing:border-box}a{color:inherit;text-decoration:inherit}audio,canvas,embed,iframe,img,object,svg,video{display:block;vertical-align:middle}button,input,optgroup,select,textarea{font-feature-settings:inherit;color:inherit;font-family:inherit;font-size:100%;font-variation-settings:inherit;font-weight:inherit;letter-spacing:inherit;line-height:inherit;margin:0;padding:0}blockquote,dd,dl,fieldset,figure,h1,h2,h3,h4,h5,h6,hr,p,pre{margin:0}fieldset,legend{padding:0}.static{position:static}", l = s, d = class {
  constructor(t) {
    o(this, t), this.state = "default";
  }
  render() {
    const t = e("span", { key: "8c6fcbfefda6302364c3dcb0aeabea9676751e65", innerHTML: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18 8.45312L6.04688 8.45312L12 2.45312L18 8.45312Z" fill="#BDC4CA" />
      <path d="M6 15.5469H17.9531L12 21.5469L6 15.5469Z" fill="#BDC4CA" />
    </svg>
      ` }), i = e("span", { key: "af968de1474e6664630441546fd2a3e2d381501a", innerHTML: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 8.45312L6.04688 8.45312L12 2.45312L18 8.45312Z" fill="black" />
        <path d="M6 15.5469H17.9531L12 21.5469L6 15.5469Z" fill="#BDC4CA" />
      </svg>
      ` }), r = e("span", { key: "e1438fe8ac5266ae12fea881fb42da8a8100ae18", innerHTML: `
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18 8.45312L6.04688 8.45312L12 2.45312L18 8.45312Z" fill="#BDC4CA" />
        <path d="M6 15.5469H17.9531L12 21.5469L6 15.5469Z" fill="black" />
      </svg>
      ` }), n = this.state === "ascending" ? i : this.state === "descending" ? r : t;
    return e(a, { key: "0e4be80fe75cdf655e658b62dddbf3064447c4a0" }, n);
  }
};
d.style = l;
export {
  d as patternlib_table_sort_arrows
};
